export default __webpack_public_path__ + "static/media/google-play.a550ca30.svg";